<template>
  <el-dialog
    :title="dialogTitle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
    :visible.sync="dialogVisible"
    width="1280px"
    top="5vh"
    center
    append-to-body
  >
    <div>
      <div style="margin-bottom: 8px; color: #E6A23C; font-size: 12px;">
        提示：修改第一条的司机/车辆时，会同步修改其他所有行；修改其他行只影响该行本身
      </div>
      <el-table
        :data="editList"
        border
        size="mini"
        height="480"
        style="width: 100%"
        v-loading="submitting"
      >
        <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
        <el-table-column prop="businessNo" label="单据号" min-width="170" :show-overflow-tooltip="true"></el-table-column>
        <!-- 司机 -->
        <el-table-column label="司机" width="160">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.driverId"
              filterable
              placeholder="请选择"
              size="mini"
              @change="rowSijiChange(scope.row, $event)"
            >
              <el-option v-for="item in sijiList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="driverPhone" label="司机电话" width="110"></el-table-column> -->
        <!-- 车辆 -->
        <el-table-column label="车辆" width="150">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.plateNumber"
              filterable
              placeholder="请选择"
              size="mini"
              @change="rowCarChange(scope.row, $event)"
            >
              <el-option v-for="item in carList" :label="item.vhcNo" :value="item.vhcNo" :key="item.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- 数量 -->
        <el-table-column prop="quantity" :label="quantityLabel" width="100"></el-table-column>
        <!-- 站点不含税单价 / 不含税单价 -->
        <el-table-column :label="isDian ? '不含税单价(元/度)' : '站点不含税单价(' + unitLabel + ')'" width="160">
          <template slot-scope="scope">
            <el-input
              placeholder=""
              maxlength="50"
              size="mini"
              v-model="scope.row.stationUnitPrice"
              @change="recalcStation(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
        <!-- 站点不含税金额（自动计算） -->
        <el-table-column prop="stationAmount" label="站点不含税金额" width="120"></el-table-column>
        <!-- 司机扣除加注量（只读） -->
        <el-table-column prop="driverDeductionQuantity" :label="'司机扣除' + quantityName" width="140" v-if="!isDian"></el-table-column>
        <!-- 司机扣除单价 -->
        <el-table-column label="司机扣除单价(元)" width="140" v-if="!isDian">
          <template slot-scope="scope">
            <el-input
              placeholder=""
              maxlength="50"
              size="mini"
              v-model="scope.row.driverUnitPrice"
              @change="recalcDriver(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
        <!-- 司机扣除金额（自动计算） -->
        <el-table-column prop="amount" label="司机扣除金额(元)" width="130" v-if="!isDian"></el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { toFixed } from '@/utils/util'
import { updateOilGasFee } from '@/api/newTMS'
import { cDlists, cVIlists } from '@/api/vgs-driver2.0'

export default {
  name: 'BatchEditDialog',
  props: {
    // 弹框显示/隐藏
    visible: {
      type: Boolean,
      default: false
    },
    // 当前tab：you=加油 qing=加气 dian=充电
    activeName: {
      type: String,
      default: 'you'
    },
    // 选中的表格数据
    selectedRows: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      submitting: false,
      editList: [],
      sijiList: [],
      carList: []
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    isDian () {
      return this.activeName === 'dian'
    },
    dialogTitle () {
      const tabLabel = this.activeName === 'you' ? '加油费' : this.activeName === 'qing' ? '加气费' : '充电费'
      return '批量修改 - ' + tabLabel
    },
    unitLabel () {
      return this.activeName === 'you' ? '元/升' : this.activeName === 'qing' ? '元/方' : '元/度'
    },
    quantityName () {
      return this.activeName === 'you' ? '加注量(升)' : this.activeName === 'qing' ? '加注量(方)' : '充电量(度)'
    },
    quantityLabel () {
      return this.activeName === 'you' ? '加注量(升)' : this.activeName === 'qing' ? '加注量(方)' : '充电量(度)'
    }
  },
  created () {
    // 司机、车辆列表（参考 driverVehicleForm 的加载方式）
    cDlists({ driverClassify: 2, tenantId: localStorage.getItem('tenantCode') }).then(res => { this.sijiList = res })
    cVIlists({ vhcClassify: 2, trailerFlag: 0, tenantId: localStorage.getItem('tenantCode') }).then(res => {
      this.carList = res
    })
  },
  watch: {
    visible (val) {
      if (val) {
        this.initEditList()
      }
    }
  },
  methods: {
    // 初始化可编辑数据（深拷贝，记录原始税率比例用于重新计算）
    initEditList () {
      this.editList = this.selectedRows.map(row => {
        // 深拷贝：每行数据完全独立，与页面表格数据、其他行均不共享任何引用
        const item = JSON.parse(JSON.stringify(row))
        // 记录含税单价/不含税单价 的原始比例，改单价后按该比例重算含税值
        const price = parseFloat(item.stationUnitPrice)
        const priceTax = parseFloat(item.stationUnitPriceTax)
        item.taxRatioCache = (price && !isNaN(price) && priceTax && !isNaN(priceTax)) ? priceTax / price : null
        return item
      })
    },
    handleClose () {
      this.dialogVisible = false
      this.editList = []
    },
    // 行-司机选择（参考 driverVehicleForm.sijiChange）
    // 第一行的司机改动会同步到其他所有行；其他行只改自己
    rowSijiChange (row, e) {
      if (!e) return
      const json = this.sijiList.filter(item => item.id == e)
      if (!json.length) return
      const d = json[0]
      const targets = (row === this.editList[0]) ? this.editList : [row]
      targets.forEach(target => {
        this.$set(target, 'driverId', e)
        this.$set(target, 'driverName', d.name)
        this.$set(target, 'driverPhone', d.mobile)
        this.$set(target, 'idNumber', d.identityNo)
        this.$set(target, 'rootTissueId', d.companyOrgId)
        this.$set(target, 'rootTissueCode', d.companyOrgCode)
        this.$set(target, 'rootTissueName', d.companyOrgName)
        this.$set(target, 'teamOrgId', d.teamOrgId)
        this.$set(target, 'teamOrgName', d.teamOrgName)
        this.$set(target, 'teamCode', d.teamOrgCode)
        this.$set(target, 'teamName', d.teamOrgName)
        this.$set(target, 'teamId', d.teamOrgId)
      })
    },
    // 行-车辆选择（参考 driverVehicleForm.carChange）
    // 第一行的车辆改动会同步到其他所有行；其他行只改自己
    rowCarChange (row, e) {
      if (!e) return
      const json = this.carList.filter(item => item.vhcNo == e)
      if (!json.length) return
      const v = json[0]
      const targets = (row === this.editList[0]) ? this.editList : [row]
      targets.forEach(target => {
        this.$set(target, 'plateNumber', e)
        this.$set(target, 'vehicleId', v.id)
        this.$set(target, 'licensePlateColorName', v.noColourName)
        this.$set(target, 'trailerPlate', v.trailerNo)
        this.$set(target, 'vehicleTypeName', v.vhcTypeName)
        this.$set(target, 'vehicleTeamId', v.teamOrgId)
        this.$set(target, 'vehicleTeamCode', v.teamOrgCode)
        this.$set(target, 'vehicleTeamName', v.teamOrgName)
      })
    },
    // 行-站点不含税单价修改后重新计算（参考单条修改的计算规则）
    recalcStation (row) {
      const price = parseFloat(row.stationUnitPrice)
      if (isNaN(price)) {
        this.$message.error('请输入正确的单价')
        return
      }
      const quantity = parseFloat(row.quantity)
      if (this.isDian) {
        // 充电：含税单价 = 不含税单价，含税金额 = 不含税金额 = 单价 × 充电量
        this.$set(row, 'stationUnitPriceTax', toFixed(price, 2))
        if (!isNaN(quantity)) {
          this.$set(row, 'stationAmount', toFixed(price * quantity, 2))
          this.$set(row, 'stationAmountTax', row.stationAmount)
        }
      } else {
        // 加油/加气：按原始税率比例重算含税单价，再重算不含税/含税金额
        if (row.taxRatioCache) {
          this.$set(row, 'stationUnitPriceTax', toFixed(price * row.taxRatioCache, 2))
        }
        if (!isNaN(quantity)) {
          this.$set(row, 'stationAmount', toFixed(price * quantity, 2))
          if (row.stationUnitPriceTax && !isNaN(parseFloat(row.stationUnitPriceTax))) {
            this.$set(row, 'stationAmountTax', toFixed(parseFloat(row.stationUnitPriceTax) * quantity, 2))
          }
        }
      }
    },
    // 行-司机扣除单价修改后重新计算司机扣除金额
    recalcDriver (row) {
      const price = parseFloat(row.driverUnitPrice)
      if (isNaN(price)) {
        this.$message.error('请输入正确的司机扣除单价')
        return
      }
      const quantity = parseFloat(row.driverDeductionQuantity)
      if (!isNaN(quantity)) {
        this.$set(row, 'amount', toFixed(price * quantity, 2))
      }
    },
    // 校验数字
    isValidNumber (val) {
      if (val === '' || val === null || val === undefined) return true
      return !isNaN(parseFloat(val)) && isFinite(val)
    },
    // 统一保存
    handleSave () {
      // 逐行校验
      for (let i = 0; i < this.editList.length; i++) {
        const row = this.editList[i]
        if (!this.isValidNumber(row.stationUnitPrice)) {
          this.$message.error('第' + (i + 1) + '行站点不含税单价输入有误')
          return
        }
        if (!this.isDian && !this.isValidNumber(row.driverUnitPrice)) {
          this.$message.error('第' + (i + 1) + '行司机扣除单价输入有误')
          return
        }
      }
      // 去掉内部辅助字段
      const updateList = this.editList.map(row => {
        const item = { ...row }
        delete item.taxRatioCache
        return item
      })
      const formData = new FormData()
      formData.set('params', JSON.stringify({ updateList: updateList }))

      this.submitting = true
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      // 加油/加气/充电 统一走 updateOilGasFee
      updateOilGasFee(formData).then(res => {
        loading.close()
        this.submitting = false
        this.$message({
          message: '批量修改成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.$emit('success')
      }).catch(error => {
        this.submitting = false
        this.$message({
          showClose: true,
          message: error.message || '批量修改失败',
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-table .el-input .el-input__inner {
  width: 110px;
}
/deep/ .el-input.is-disabled .el-input__inner {
  color: #333;
}
</style>
